export default __webpack_public_path__ + "static/media/burgerBreakfast.6243e40a.svg";